import { type NewCoreIconProps } from '@atlaskit/icon';
import React from 'react';

export const AiSummaryIcon = ({
  color = 'currentColor',
  label,
  testId,
}: NewCoreIconProps) => (
  <span
    aria-label={label || undefined}
    data-testid={testId}
    role={label ? 'img' : undefined}
    style={{ color, display: 'inline-flex' }}
  >
    <svg
      aria-hidden={label ? undefined : true}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12.499V13.999H1V12.499H6ZM9.5 7.25V8.75H1V7.25H9.5ZM15 2V3.5H1V2H15Z"
        fill="currentColor"
      />
      <path
        d="M12.5 9C12.8151 9 13.0971 9.19714 13.2051 9.49316L13.8193 11.1797L15.5068 11.7949C15.8029 11.9029 16 12.1849 16 12.5L15.9912 12.6162C15.9496 12.8828 15.766 13.1106 15.5068 13.2051L13.8193 13.8193L13.2051 15.5068C13.1106 15.766 12.8828 15.9496 12.6162 15.9912L12.5 16C12.1849 16 11.9029 15.8029 11.7949 15.5068L11.1797 13.8193L9.49316 13.2051C9.23402 13.1106 9.05042 12.8828 9.00879 12.6162L9 12.5C9 12.1849 9.19714 11.9029 9.49316 11.7949L11.1797 11.1797L11.7949 9.49316C11.8894 9.23402 12.1172 9.05042 12.3838 9.00879L12.5 9Z"
        fill="currentColor"
      />
    </svg>
  </span>
);
